import * as storage from '../utils/storage';
import { logout } from '../actions/authentication';
import { renewToken } from '../actions/authentication';
import * as LoginCode from '../scripts/StatusLoginCode';
import { renewTokenSuccess } from '../actions/login';
import jwt from 'jwt-decode';
import * as cookie from '../scripts/CookiesAppGo';

export async function ValidateToken(props) {
    let hasToken = storage.getToken();

    // Validate if there's no token or it is expired
    if (hasToken == null || jwt(storage.getToken()).exp < Date.now() / 1000) {
        logout(true);
    } else {
        const { cookies } = props;

        let interval = 60000 * 10;// 10 minutes => default if not set in the appconfig
        const validateMinutesInterval = storage.getConfigValidateMinutesInterval();
        if (validateMinutesInterval !== undefined && validateMinutesInterval > 0) {
            interval = validateMinutesInterval * 60000;
        }

        // if you want to test, uncomment the line below. This will set to 5 seconds
        //interval = 5000;

        setInterval(() => {
            const dateLogin = cookies.get(cookie.login);

            const successDateLogin = new Date(dateLogin);
            const currentDate = new Date();

            const minutesToken = storage.getConfigRenewMinutes();

            let renewTokenMinutes = (minutesToken !== undefined && minutesToken > 0) ? minutesToken : 30;

            // if you want to test, uncomment the line below. This will set to 2 minutes
            //renewTokenMinutes = 2;

            var diff = Math.abs(currentDate - successDateLogin);
            var minutesDiff = Math.round((diff / 1000) / 60);

            if (minutesDiff >= renewTokenMinutes && hasToken != false) {
                cookies.set(cookie.token_timeout, true, { path: '/' });
            }

        }, interval);
    }
}

export function RenewToken(props) {
    return new Promise((resolve) => {
        renewToken().then((result) => {
            const { cookies } = props;

            cookies.set(cookie.token_timeout, false, { path: '/' });
            cookies.set(cookie.login, new Date().toLocaleString(), { path: '/' });

            if (result.statusLogin === LoginCode.LOGIN_SUCCESSFULL) {
                renewTokenSuccess(result.token);
                resolve();
            }
            else {
                logout(true);
            }
        });
    })
}